import http from "../BaseServiceHttp";

class FileService {
  downloadTemplate(factoryId) {
    return http.get(`/factories/${factoryId}/products/export-excel-template`, { responseType: "blob" });
  }
}

export default new FileService();
